import React from 'react';
import { priceFormat } from '../../../../../helpers/calculateDiscountAndCredits';

import './styles.scss';

const BundlePrice = (props) => {
  const {
    isLandingTicket,
    landingTicket,
    oldPrice,
    finalPrice,
    formattedFinal,
    loyaltyTickets,
    ticketsAmount,
    baseTicketsAmount,
    isDouble,
  } = props;
  const isTicketPriceChanged = loyaltyTickets || (oldPrice !== finalPrice) || isDouble;
  const actualTicketsAmount = ticketsAmount + loyaltyTickets;
  return (
    <div className="bundle-price__info">
      <div className="bundle-price__prices">
        <p className="bundle-price__price">
          {isLandingTicket ? priceFormat(landingTicket.totalCost * landingTicket.discountValue) : formattedFinal}
        </p>
        {oldPrice && oldPrice !== finalPrice && (
          <p className="bundle-price__old-price">{priceFormat(Math.round(oldPrice))}</p>
        )}
      </div>
      <div className="bundle-price__tickets">
        {isTicketPriceChanged && (
          <span className="bundle-price__ticket-old-price">{Math.round((oldPrice * 100) / baseTicketsAmount)}p</span>
        )}
        <span className="bundle-price__ticket-price">{Math.round((finalPrice * 100) / actualTicketsAmount)}p / ticket</span>
      </div>
    </div>
  );
};

export default BundlePrice;
